import React, { useContext, useEffect, useRef } from "react";
import DocumentContext from "../../ContextDocument";
import { parseToFolio } from "helpers/documents";
import ui from "./styles.module.scss";
import { PopUpDocumentsRelated } from "helpers/Apis/Documents";

export default function DocNumber() {
  const hook = useContext(DocumentContext);
  // PopUpDocumentsRelated()

  const INDEXED_LABELS = useRef({
    1: "Cotización",
    2: "Pedido",
    3: "Orden de compra",
    6: "Contrato",
  });

  if(!hook.folio) return <></>;

  return (
    <>
      <div className={ui.containerDocNumber}>
        <p>No. {INDEXED_LABELS.current[hook.documentType] || " documento"}</p>
        <p>{parseToFolio(hook.folio)}</p>
      </div>
      <InvoiceNumber
        isPreinvoice={hook.documentType === 2}
        idDocument={hook.id || null}
      />
    </>
  );
}

function InvoiceNumber({ isPreinvoice = false, idDocument = null }) {
  const [docNumber, setDocNumber] = React.useState(0);

  const canShow = isPreinvoice && typeof idDocument === "number";

  useEffect(() => {
    if (!canShow) return;

    PopUpDocumentsRelated(idDocument).then((overview) => {
      const invoiceExists = overview.data.fe !== null;

      if (invoiceExists) {
        setDocNumber(+overview.data.fe.folio);
      }
    });
  }, [idDocument, isPreinvoice]);

  if (!canShow || docNumber === 0) return <></>;

  return (
    <div className={ui.containerDocNumber}>
      <p>No. Factura</p>
      <p>{parseToFolio(docNumber)}</p>
    </div>
  );
}
